module.exports = __webpack_public_path__ + "static/img/pic120px_qs_zwmx@2x.926228fa.png";